'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.card-root {\n  border-radius: 16px;\n  box-shadow: 2px 4px 16px 0px rgba(163, 177, 198, 0.5);\n}\n.card-root .line {\n  background-color: #1D66DD;\n  height: 12px;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n}\n.card-root .content {\n  padding: 32px;\n  padding-top: 36px;\n  padding-bottom: 40px;\n  position: relative;\n  border-bottom-left-radius: 16px;\n  border-bottom-right-radius: 16px;\n  background-color: #fff;\n}");
//# sourceMappingURL=Card.scss.js.map
